<div class="widget-tile">
  <span>{{ widgetDataHolder.title }}</span>
  <div *ngFor="let dataItem of widgetDataHolder.data.entries()">
    <span class="tile-text">{{ dataItem[0] }}</span>
    <div id="progressbar">
      <div [style.width]="getWidthFor(dataItem[1])">{{ dataItem[1] }}</div>
    </div>
  </div>
</div>
